/**
 * @fileoverview Food theme - match food and drink emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

/**
 * Food theme with yummy food and drink emojis.
 */
export class FoodTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'food',
            'Food',
            allLabels.food,
            { numPairs: 4, isPremium: false, hasMovement: false, ...options }
        );
    }
}
